import { combineReducers } from 'redux'
import visitor from './visitorSlice'

export default combineReducers({
   visitor
})